import { defineComponent as _defineComponent } from 'vue'
import { ref, onMounted, onUnmounted, computed } from 'vue';
import { useRouter } from 'vue-router';
import { getUserId, logout } from '../util/auth';
import { checkLoggedIn, isAdmin } from '@/util/auth'
import events from "../events";
import { DataInstance } from '@busy-human/gearbox';
import { Userspaces } from '@busy-human/opt-library';
import useClickOutside from '../composables/useClickOutside'

import hamburger from '../components/hamburger-icon.vue';
import { useUserspace } from '@/store/userspace';
// import router from "../router";


export default /*#__PURE__*/_defineComponent({
  __name: 'navbar',
  setup(__props, { expose }) {
  expose();

const navMenu = ref()
useClickOutside(navMenu, ()=> {
    showMenu.value = false
})
const router = useRouter();

const userspace = useUserspace();

const handleUnproxy = async () => {
    await router.push({name: 'Admin Proxy'});
    await userspace.resetSpace();
}

const showMenu = ref(false);

const goTo = (route: string) => {
    router.push(route)
}

let handleNavClick = () => {
    router.push("/");
}

let handleProfileClick = () => {
    router.push("/settings");
}
let handleLogoutClick = async () => {
    await logout()
    router.push("/auth");
};
let user = computed<DataInstance<Userspaces.Model> | null>(() => {
    const tmp = userspace.user;
    if(tmp.$id) return tmp;
    else return null;
})

const checkSetup = computed(() =>{
    let isLoggedIn = checkLoggedIn()
    if(isLoggedIn){
        let userspace =  useUserspace().user
        if (userspace.setupCompleted.length < 2){
            return true
        }else{
            return false
        }
    }
    return false
})

const __returned__ = { navMenu, router, userspace, handleUnproxy, showMenu, goTo, handleNavClick, handleProfileClick, handleLogoutClick, user, checkSetup, ref, onMounted, onUnmounted, computed, useRouter, getUserId, logout, checkLoggedIn, isAdmin, events, DataInstance, Userspaces, useClickOutside, hamburger, useUserspace }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})